import styled from '@emotion/styled';

import { COLOR_TEXT_MUTED } from './utils/variables';

export const FieldHint = styled.span`
  font-size: 12px;
  color: ${COLOR_TEXT_MUTED};
  line-height: 1.4;
`;
